import {AtalayaWrapper} from '@therms/atalaya'
import {
  AppWrapper2,
  DownloadsApiServiceContextProvider,
  resolveFileName,
  RouterContextProvider,
  RPCContextProvider,
  rpcResponseInterceptorLogger,
  useLocalStorage,
} from '@therms/react-modules'
import {RPCClientOptions, TransportType} from '@therms/rpc-client'
import {createBrowserHistory} from 'history'
import {StrictMode} from 'react'
import {Router} from 'react-router-dom'
import {GLOBALS} from '../build-env'
import {AppRouter} from './AppRouter'
import {DownloadsApiClientConfig} from '@therms/downloads-api'

const rpcOptions: RPCClientOptions = {
  hosts: {
    http: GLOBALS.RPC_HTTP_HOST,
    websocket: GLOBALS.RPC_WS_HOST,
  },
  responseInterceptor: rpcResponseInterceptorLogger,
  transportOptions: {
    preferredTransport: TransportType.http,
  },
}

const downloadsApiConfig: DownloadsApiClientConfig = {
  basePath: GLOBALS.BASE_DOWNLOADS_API_URL,
  hooks: {
    onError: (context) => {
      // todo: need to log errors and send to sentry
    },
  },
}

console.log('Build:', GLOBALS.BUILD_DATE, 'RPC HOSTS', rpcOptions.hosts)

export const history = createBrowserHistory({basename: '/profile'})
export function App() {
  return (
    <StrictMode>
      <RPCContextProvider options={rpcOptions}>
        <DownloadsApiServiceContextProvider clientConfig={downloadsApiConfig}>
          <RouterContextProvider history={history}>
            <AtalayaWrapper resolveFileName={resolveFileName}>
              <AppWrapper2
                currentAppId="profile"
                currentAppVersion={GLOBALS.BUILD_DATE}
              >
                <Router history={history}>
                  <AppRouter />
                </Router>
              </AppWrapper2>
            </AtalayaWrapper>
          </RouterContextProvider>
        </DownloadsApiServiceContextProvider>
      </RPCContextProvider>
    </StrictMode>
  )
}
